module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("You seem to have taken a wrong turn.")]), _vm._v(" "), _c('p', [_vm._v("Your body floats into the darkness of space, frozen for five hundred years.")]), _vm._v(" "), _c('p', [_vm._v("It will be consumed by a passing Ewii as fuel.")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Return to homepage")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('small', [_vm._v("(404 File not Found)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb559fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/404.vue
// module id = 274
// module chunks = 1